import { validateBr } from "js-brasil";
import * as Yup from "yup";

import { EstadoCivil, Genero, SegmentoSimulacao } from "#/enums";
import {
  ERRO_CPF,
  ERRO_PADRAO,
  ERRO_PADRAO_CEP,
  ERRO_PADRAO_DIA,
  ERRO_PADRAO_ESTADO_CIVIL,
  ERRO_PADRAO_GENERO,
} from "./errosForm";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);

export const VALIDACAO_CEP = Yup.string()
  .length(9, ERRO_PADRAO_CEP)
  .required(ERRO_PADRAO);

export const VALIDACAO_PADRAO_TEXTO = Yup.string().required(ERRO_PADRAO);

export const VALIDACAO_PADRAO_NUMERICA = Yup.number()
  .required(ERRO_PADRAO)
  .typeError(ERRO_PADRAO_DIA);

export const VALIDACAO_PADRAO_DIA = VALIDACAO_PADRAO_NUMERICA.min(
  1,
  ERRO_PADRAO_DIA
).max(31, ERRO_PADRAO_DIA);

export const VALIDACAO_PADRAO_BOOLEAN = Yup.boolean().required(ERRO_PADRAO);

export const VALIDACAO_ARRAY = Yup.array().required(ERRO_PADRAO);

export const VALIDACAO_PLACA = Yup.string().matches(
  /[A-Z]{3}-[\d][\dA-Z][\d]{2}/,
  { message: "Placa inválida" }
);

export const VALIDACAO_CHASSI = Yup.string()
  .matches(/^[a-zA-Z0-9]*$/, "Chassi deve conter somente letras e números")
  .length(17, "Chassi deve ter 17 dígitos");

export const VALIDACAO_PADRAO_DATA = VALIDACAO_PADRAO_TEXTO.test(
  "invalid-date",
  "Informe uma data válida",
  (date) => {
    return dayjs(date, "DD/MM/YYYY", true).isValid();
  }
);

export const VALIDACAO_CPF = Yup.string()
  .required(ERRO_PADRAO)
  .test("test-invalid-cpf", ERRO_CPF, (cpf) => !cpf || validateBr.cpfcnpj(cpf));

export const VALIDACAO_GENERO = Yup.mixed<Genero>()
  .oneOf(Object.values(Genero), ERRO_PADRAO_GENERO)
  .required(ERRO_PADRAO);

export const VALIDACAO_ESTADO_CIVIL = Yup.mixed<EstadoCivil>()
  .oneOf(Object.values(EstadoCivil), ERRO_PADRAO_ESTADO_CIVIL)
  .required(ERRO_PADRAO);

export const VALIDACAO_SEGMENTO = Yup.mixed<SegmentoSimulacao>()
  .oneOf(Object.values(SegmentoSimulacao), ERRO_PADRAO)
  .required(ERRO_PADRAO);
